import { render } from "./Sound.vue?vue&type=template&id=f6d7f9ce&ts=true"
import script from "./Sound.vue?vue&type=script&lang=ts"
export * from "./Sound.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__